import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { PrivateRoute } from "./routes/PrivateRoute";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import PagePrivate from "./pages/PagePrivate";
import KpiProduccion from "./pages/KPI_Produccion";
import Documentos from "./pages/Documentos";
import Dashboard from "./pages/Dashboard";
import SeguridadSalud from "./pages/Seguridad_y_salud";
import MapaProyectos from "./pages/MapaProyectos";
import ProfileUser from "./pages/ProfileUser";
import ResetPassword from "./pages/ResetPassword.js";
import CostStructure from "./pages/CostStructure.js";
import Geologia from "./pages/Geologia.js"
import PanelAdmin from "./pages/panelAdmin.js";
import { Box, CircularProgress } from "@mui/material";
import LanguageSwitcher from "./components/LanguageSwitcher.jsx";
import { EmailVerifiedRoute } from "./context/EmailVerifiedRoute.jsx";
import ProjectSidebarLayout from "./components/ProjectSidebarLayout.jsx";
import "./utils/i18n.js";

const AppRoutes = () => {
  const { auth, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Routes>
      <Route element={<PrivateRoute allowedRoles={["admin", "superAdmin", "testing"]} />}>

        <Route path="/panel" element={<PagePrivate />}>
          <Route path="historico/:wellId" element={<Dashboard />} />
          <Route path="geologia/:wellId" element={<Geologia/>} />
          <Route path="diario/:wellId" element={<KpiProduccion />} />
          <Route path="seguridad-salud/:wellId" element={<SeguridadSalud />} />
          <Route path="profile/:wellId" element={<ProfileUser />} />
          <Route path="panel-admin/:wellId" element={<PanelAdmin />} />
          <Route path="documentos/:wellId" element={<Documentos />} />
          <Route path="cost-structure/:wellId" element={<CostStructure />} />
        </Route>
        <Route path="/panel/mapa-proyecto" element={<ProjectSidebarLayout><MapaProyectos /></ProjectSidebarLayout>} />
      </Route>
      <Route path="/" element={!auth ? <Login /> : <Navigate to="/panel/mapa-proyecto" replace />} />
      <Route path="/panel/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <LanguageSwitcher />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;